import { PickMonth } from "../PichMonth/PickMonth";
import PickTime from "../PickTime/PickTime";

import "./style.css"

const PickDate = () => {
	return (
		<div className="pick-date">
			<PickMonth />
			<PickTime />
		</div>
	)
}

export default PickDate